import React, { useState } from "react";
import "../../styles/Modals.css";
import ClosedIcon from "../../icons/ClosedIcon";
import RejectedVendorIcon from "../../icons/Arrows/RejectedVendorIcon";
import { translateLabel, translateText, useTranslationSnapshot } from "./../../translations/runtime";


function RejectModal({ error, isSubmitting = false, onClose, onConfirm }) {
  useTranslationSnapshot();
  const [reason, setReason] = useState("");

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>

        <div className="modal-close" onClick={onClose}>
          <ClosedIcon />
        </div>

        <div className="modal-icon-circle modal-icon-circle-red">
          <RejectedVendorIcon />
        </div>

        <div className="modal-title">Reject Vendor Application</div>
        <div className="modal-subtitle">
          Please provide a reason for rejection. This will be communicated to the vendor
        </div>

        <div className="modal-form">
          <div className="modal-form-label">{translateLabel("txt_admin_rejection_reason", "Rejection Reason")}<span>*</span></div>
          <textarea
            className="modal-textarea"
            placeholder={translateLabel("txt_admin_explain_why_this_application_is_being_rejected", "Explain why this application is being rejected...")}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        {error && <div className="modal-error">{translateText(error)}</div>}

        <div className="modal-footer">
          <button
            className="modal-btn-cancel"
            disabled={isSubmitting}
            onClick={onClose}
          > {translateLabel("btn_cancel", "Cancel")} </button>
          <button
            className="modal-btn-reject"
            disabled={isSubmitting}
            onClick={() => onConfirm(reason)}
          >
            {isSubmitting ? translateLabel("txt_admin_rejecting", "Rejecting...") : translateLabel("txt_admin_reject_application", "Reject Application")}
          </button>
        </div>

      </div>
    </div>
  );
}

export default RejectModal;
